import React, { useEffect } from "react";

const RainEffect = () => {
  useEffect(() => {
    const createRain = () => {
      const rainContainer = document.createElement("div");
      rainContainer.classList.add("rain");
      document.body.appendChild(rainContainer);

      const totalDrops = 200;// Numri i pikave të shiut

      for (let i = 0; i < totalDrops; i++) {
        const drop = document.createElement("div");
        drop.classList.add("raindrop");

        // Pozicioni horizontal dhe koha e animacionit
        drop.style.left = Math.random() * 100 + "vw";
        drop.style.animationDuration = Math.random() * 2 + 1 + "s"; // Midis 1-3 sekonda
        drop.style.animationDelay = Math.random() * 5 + "s"; // Vonesa për efekt natyral

        rainContainer.appendChild(drop);
      }
    };

    createRain();

    return () => {
      // Pastron flluskat kur komponenti çaktivizohet
      const rain = document.querySelector(".rain");
      if (rain) rain.remove();
    };
  }, []);

  return null; // Nuk ka UI të drejtpërdrejtë, vetëm animacion në sfond
};

export default RainEffect;
